// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__jIycR","header":"ReportDetails_header__7PYVS","title":"ReportDetails_title__3DuzD","left":"ReportDetails_left__E0l2v"};